import * as lenis from './lenis';
import * as Utils from './utils.js';

export default el => {
	const btns = document.querySelectorAll(`[aria-controls="${el.id}"]`);
	const content = el.querySelector('.js-dialog-content');
	
	btns.forEach(btn => {
		btn.addEventListener('click', () => {
			const status = el.getAttribute('aria-modal');

			if (!status || status == "false") {
				open();
				return;
			}

			close();

		})
	})

	el.addEventListener('click', (e) => {
		var content = el.querySelector('.dialog__content');
		if (!content) content = el;

		if (
			!content.contains(e.target)
			&& !e.target.closest('.js-group-product-btn-remove')
		) {
			close();
		}	
	})

	const open = () => {
		const grecaptchas = document.querySelectorAll('.g-recaptcha');
		if (grecaptchas) {
			grecaptchas.forEach(item => {
				grecaptcha.reset(item.dataset.id);
			});
		}

		lenis.destroy();

		var content = el.querySelector('.dialog__content');
		if (!content) content = el;

		content.scrollTo(0, 0);
		
		lenis.init(content);

		el.style.display = "flex";
		setTimeout(() => {
			el.setAttribute('aria-modal', true);
		}, 1)
	}

	const close = () => {
		lenis.destroy();
		lenis.init();
		el.removeAttribute('aria-modal');

		setTimeout(() => {
			el.style.display = "none";
		}, 501)

		const form = el.querySelector('form');

		if (form) {
			setTimeout(() => {
				const requiredFields = el.querySelectorAll('[required]');
				if (requiredFields) {
					Utils.removeRequiredFieldsEvents(requiredFields);
				}

				form.classList.remove('validation');

				const inputs = form.querySelectorAll('input, select, textarea, .select');
				inputs.forEach((input) => {
					if (input.type !== "checkbox" && input.type !== "radio") input.value = "";
					input.checked = false;
					input.classList.remove('results');
					// input.dispatchEvent(new Event('change'));

					const parent = input.closest('.field');
					parent.classList.remove('error');
					parent.classList.remove('active');
				})
			}, 250)
		}
	}
};
